module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-list"
  }, [(_vm.user.portfolio && _vm.user.portfolio.length > 0) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.user.portfolio), function(rt, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-item"
    }, [_c('span', {
      staticClass: "portfolio-link tl"
    }, [_c('a', {
      staticClass: "flex",
      attrs: {
        "href": _vm.universeUrl + "/" + (rt.type === 'online' ? 'roundtables' : 'live_discussions') + "/" + (rt.id),
        "target": "_blank"
      }
    }, [_vm._v("\n          " + _vm._s(rt.title) + "\n          "), _c('i', {
      staticClass: "fas fa-external-link-alt"
    })])])])
  })], 2) : _c('div', {
    staticClass: "center-xs",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('span', [_vm._v(" No RoundTables ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('span', {
    staticClass: "b course-header"
  }, [_vm._v("Name of RoundTable")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-684e2726!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/userDetailsModal/portfolioTabContent.vue
// module id = 2051
// module chunks = 61